
import { useEffect, useState } from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';





export const AutocompleteMultiple = ({ label, options=[], disabled = false, size, value=[], 
                                        onChange, name, helperText, ...props }) => {


    const [selectedValues, setSelectedValues] = useState([]);
    

    useEffect(() => {
        setSelectedValues(value || []);
    }, [value]);



    const handleChange = (newValue) => {
        const newArray = newValue.map(item => item.id);
        setSelectedValues(newArray);
        onChange?.({ target: { name, value: newArray } });
    };




    return (
        <Autocomplete
            multiple
            options={options}
            value={options.filter(option => selectedValues.includes(option.id))}
            getOptionLabel={(option) => option.nombre}
            onChange={(_, newValue) => handleChange(newValue)}
            disableCloseOnSelect
            size={size}
            disabled={disabled}
            renderInput={(params) => (
                <TextField
                    {...params}
                    label={label}
                    helperText={helperText}
                    autoComplete="off"
                    size={size}
                    {...props}
                />
            )}
        />
    );
};
